import {localStorage} from 'utilities/storage';

const storageKey = userId => `dm:${userId}:user-prefs`;

export const fetchPreferencesFromStorage = userId =>
  Promise.resolve().then(() => {
    const rawValue = localStorage.getItem(storageKey(userId)) || '{}';
    return JSON.parse(rawValue);
  });

export const patchPreferencesToStorage = (userId, preferences) =>
  fetchPreferencesFromStorage(userId).then(existing => {
    const merged = {...existing, ...preferences};
    localStorage.setItem(storageKey(userId), JSON.stringify(merged));
    return merged;
  });
